import { Component, inject, OnInit, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { LogService } from '../../services/log.service';
import { Log } from '../../models/log';
import { HeaderComponent } from '../../components/header/header.component';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Feeling } from '../../models/feeling';
import { BodyReaction } from '../../models/body-reaction';
import { ButtonComponent } from '../../components/button/button.component';
import TYPES from '../../constants/types';
import { FeelingService } from '../../services/feeling.service';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { BodyReactionService } from '../../services/body-reaction.service';

@Component({
  selector: 'app-log-viewer',
  imports: [
    HeaderComponent,
    TranslatePipe,
    ButtonComponent
  ],
  templateUrl: './log-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './log-viewer.component.scss'
})
export class LogViewerComponent implements OnInit {

  logService: LogService<Log> = inject(LogService);
  feelingService: FeelingService<Feeling> = inject(FeelingService);
  bodyReactionService: BodyReactionService<BodyReaction> = inject(BodyReactionService);
  authService: AuthService = inject(AUTH_SERVICE);
  userFullName: string = '';
  allFeelings: Feeling[] = [];
  selectedFeelings: WritableSignal<Feeling[]> = signal<Feeling[]>([]);
  allBodyReactions: BodyReaction[] = [];
  selectedBodyReactions: WritableSignal<BodyReaction[]> = signal<BodyReaction[]>([]);
  
  BUTTON_TYPES:any = TYPES.UI.BUTTON;
  moods:any = TYPES.APPLICATION.MOODS;
  mood:any;

  constructor(private route: ActivatedRoute){

    this.mood = this.getMood(this.logService.log().mood);

    this.route.queryParams.subscribe(params => {
      if (params['data']) {
        this.userFullName = JSON.parse(params['data']);
      }
    });
  }

  async ngOnInit() {
    
    let customFeelings: Feeling[];
    if (!localStorage.getItem('custom-feelings')){
      customFeelings = await this.feelingService.getAllCustomFeelingsFromUser(this.authService.user()?.id || '');
      localStorage.setItem('custom-feelings', JSON.stringify(customFeelings));
    }else{
      customFeelings = JSON.parse(localStorage.getItem('custom-feelings') || '');
    }
    
    let systemFeelings: Feeling[];
    if (!localStorage.getItem('system-feelings')){
      systemFeelings = await this.feelingService.getAllSystemFeelings();
      localStorage.setItem('system-feelings', JSON.stringify(systemFeelings));
    }else{
      systemFeelings = JSON.parse(localStorage.getItem('system-feelings') || '');
    }

    this.allFeelings = systemFeelings.concat(customFeelings);

    let customBodyReactions: BodyReaction[];
    if (!localStorage.getItem('custom-body-reactions')){
      customBodyReactions = await this.bodyReactionService.getAllCustomBodyReactionsFromUser(this.authService.user()?.id || '');
      localStorage.setItem('custom-body-reactions', JSON.stringify(customBodyReactions));
    }else{
      customBodyReactions = JSON.parse(localStorage.getItem('custom-body-reactions') || '');
    }
    
    let systemBodyReactions: BodyReaction[];
    if (!localStorage.getItem('system-body-reactions')){
      systemBodyReactions = await this.bodyReactionService.getAllSystemBodyReactions();
      localStorage.setItem('system-body-reactions', JSON.stringify(systemBodyReactions));
    }else{
      systemBodyReactions = JSON.parse(localStorage.getItem('system-body-reactions') || '');
    }

    this.allBodyReactions = systemBodyReactions.concat(customBodyReactions);

    const feelingsSplit = this.logService.log().feelings?.split(';') || [];
    for(const feelingId of feelingsSplit){  
      this.selectedFeelings.update(
        (current) => {
          return current.concat(
            this.allFeelings.filter( 
            (item) => 
            {
              return item.id == feelingId
            })
          );   
        }
      );
    }

    const bodyReactionsSplit = this.logService.log().body_reactions?.split(';') || [];
    for(const bodyReactionId of bodyReactionsSplit){
      this.selectedBodyReactions.update(
        (current) => {
          return current.concat(
            this.allBodyReactions.filter( 
            (item) => 
            {
              return item.id == bodyReactionId
            })
          );
        }
      );
    }
  }

  back(){
    history.back();
  }

  getMood(label:string|null){
    return this.moods.filter(
      (item:any) => {
        return item.label === label;
      }
    )[0];
  }

}
